import { defineMessages } from "react-intl";

const baseId = "t.pages.DelegationManagementStepTwo.";

export default defineMessages({
  mainTitle: {
    id: baseId + "mainTitle",
    defaultMessage: "Select role",
  },
  continueCTA: {
    id: baseId + "continueCTA",
    defaultMessage: "Continue",
  },
  backCTA: {
    id: baseId + "backCTA",
    defaultMessage: "Back",
  },
  emptyRoles: {
    id: baseId + "emptyRoles",
    defaultMessage: "No delegable role available",
  },
});
